// store/modules/userPermission.js

import { UserPermissionService } from '@/services/UserPermission.service';

const getDefaultState = () => {
  return {
    refreshMenu: true,
    userPermissions: {},
    userName: '',
    permissions: [],
    lastUpdated: null,
    isAdmin: {},
  };
};

const state = getDefaultState();

const mutations = {
  setUserPermissions(state, { userName, permissions, userInfo = {} }) {
    state.userName = userName;
    state.userPermissions[userName] = permissions;
    state.userInfo = userInfo;
  },

  setMenuSideRerender(state, isPage) {
    state.refreshMenu = isPage || true;
  },

  setUserPermissionsDefault(state) {
    Object.assign(state, getDefaultState());
  },

  SET_PERMISSION(state, data = []) {
    state.permissions = data;
  },

  SET_IS_ADMIN(state, { isAdmin }) {
    state.isAdmin = isAdmin;
  },
  // // Optional: If you want a mutation that can reset the state globally
  // [SET_DEFAULT](state) {
  //   Object.assign(state, getDefaultState());
  // },
};

const getters = {
  userPermissions: (state) => state.userPermissions[state.userName],

  isAdmin(state) {
    return state.isAdmin;
  },

  hasPermission: (state) => (permission) => {
    // If user is admin, grant all permissions
    if (state.isAdmin == true) {
      return true;
    }

    // Get user's permissions array
    const userPerms = state.userPermissions[state.userName] || [];

    // If permission is an array, check if any of the permissions match
    if (Array.isArray(permission)) {
      return permission.some((p) => userPerms.includes(p));
    }

    // If permission is a string, check if it exists in user's permissions
    return userPerms.includes(permission);
    // return state.userName == 'admin' || state.userPermissions[state.userName].includes(permission);
  },

  menuSideRerender: (state) => state.refreshMenu || true,
  getPermissions: (state) => state.permissions,
};

const actions = {
  resetUserPermissionsState({ commit }) {
    commit('setUserPermissionsDefault');
  },

  setRefreshMenu({ commit }, value) {
    commit('setMenuSideRerender', value);
  },

  setIsAdmin({ commit }, value) {
    commit('SET_IS_ADMIN', { isAdmin: value });
  },
  // Optional: Use SET_DEFAULT mutation for global reset
  async getPermissionsUsers({ commit }) {
    const now = Date.now();
    if (!state.lastUpdated || now - state.lastUpdated > 30000) {
      const findAllPermission = await UserPermissionService.apiGetUserPermission();

      // 30 seconds threshold
      // commit("SET_DATA", { data: response.data, timestamp: now });
      commit('SET_PERMISSION', { data: findAllPermission, timestamp: now });
      return findAllPermission;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
